import { MoreVerticalOutlineIcon, ObjectIcon } from '@carboncopyco/icons';
import { Dropdown } from '@carboncopyco/ui';
import classNames from 'classnames';
import { type ReactNode, useState } from 'react';

export const RowOptions = ({
  isModified,
  onOpenChange,
  children,
}: {
  isModified: boolean;
  onOpenChange: (isOpen: boolean) => void;
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      zIndex={10}
      interactive
      align="start"
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        onOpenChange(open);
      }}
      triggerElement={
        <div className="flex items-center justify-center w-8 h-7 text-ds-natural-200 hover:text-ds-primary-300 group">
          <div
            className={classNames({
              'text-ds-marker-1': isModified,
            })}
          >
            <ObjectIcon size={13} />
          </div>
          <div
            className={classNames(
              'absolute text-ds-natural-600 bg-white group-hover:flex',
              {
                hidden: !isOpen,
              }
            )}
          >
            <MoreVerticalOutlineIcon size={16} />
          </div>
        </div>
      }
    >
      {children}
    </Dropdown>
  );
};
